import React, {useEffect, useState} from 'react';
import {ClearOutlined} from "@ant-design/icons";
import {Badge, Button, Checkbox, Drawer, Radio, Select, Space, Spin, Typography} from "antd";
import {useApiReadStudentLessonFilters} from "@/api/lesson";
import toFaNumber from "@/lib/utils/number";

const {Title, Text} = Typography;

// Helper functions

function LessonFilter({setExportFilters, open, setOpen, setCount, defaultFilters}) {
    const [selectedGenders, setSelectedGenders] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [priceRange, setPriceRange] = useState([0, 5000000]);
    const [sortBy, setSortBy] = useState('newest');
    const [currentPage, setCurrentPage] = useState(1);
    const [myFilterCount, setMyFilterCount] = useState(0)


    const [filters, setFilters] = useState(defaultFilters || {

        teacher: null,
        topic_id: null,
        group_id: null,
        course_id: null,
        grade_id: null,
        weekday: [],
        semester_id: null,
        gender: null,
        price: null,
        available_capacity: null,
        classroom_id: null,
    });

    const {data: filtersData, isPending, isSuccess} = useApiReadStudentLessonFilters();


    const [filterOptions, setFilterOptions] = useState({
        teachers: [
            {id: 0, name: "استاد"},

        ],

        groups: [
            {id: 0, title: "گروه علمی"},
        ],
        courses: [
            {id: 0, title: "رشته تحصیلی"},
        ],
        grades: [
            {id: 0, title: "مقطع تحصیلی"},

        ],
        classrooms: [
            {id: 0, title: "کلاس درس"},

        ],
        // semesters: [
        //     {id: 0, title: "ترم تحصیلی"},
        //
        // ],

        weekdays: [
            {value: 'saturday', label: 'شنبه'},
            {value: 'sunday', label: 'یکشنبه'},
            {value: 'monday', label: 'دوشنبه'},
            {value: 'tuesday', label: 'سه‌شنبه'},
            {value: 'wednesday', label: 'چهارشنبه'},
            {value: 'thursday', label: 'پنج‌شنبه'},
            {value: 'friday', label: 'جمعه'},
        ],
        genders: [
            {value: 'male', label: 'آقایان'},
            {value: 'female', label: 'بانوان'},
            {value: 'all', label: 'آقایان و بانوان'},
        ]
    });


    useEffect(() => {
        if (filtersData?.data?.data) {

            setFilterOptions(filtersData.data?.data);
        }
    }, [filtersData])

    useEffect(() => {
        setExportFilters?.(filters);
    }, [filters]);


    // Update filter function
    const updateFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
        setCurrentPage(1); // Reset to first page when filters change
    };


    // Clear all filters
    const clearAllFilters = () => {
        setFilters({

            teacher: null,
            topic_id: null,
            group_id: null,
            course_id: null,
            grade_id: null,
            weekday: [],
            semester_id: null,
            gender: null,
            price: null,
            available_capacity: null,
            classroom_id: null,
        });
        setCurrentPage(1);
    };

    const onClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        setCount(getActiveFilterCount())
        setMyFilterCount(getActiveFilterCount())
    }, [filters]);

    const getActiveFilterCount = () => {
        return Object.entries(filters).reduce((count, [key, value]) => {
            if (Array.isArray(value) && value.length > 0) {
                return count + 1;
            }
            if (value !== null && value !== '' && !(Array.isArray(value))) {
                return count + 1;
            }
            return count;
        }, 0);
    };

    return (
        <div>
            <Drawer
                title="فیلتر‌ها"
                closable={{'aria-label': 'بستن فیلتر‌ها'}}
                onClose={onClose}
                placement={'left'}
                open={open}
                extra={
                    <Space>
                        <Badge count={myFilterCount ? toFaNumber(myFilterCount) : 0}>
                            <Button
                                type="text"
                                icon={<ClearOutlined/>}
                                onClick={clearAllFilters}
                                size="small"
                            >
                                پاک کردن همه
                            </Button>
                        </Badge>
                    </Space>
                }
            >
                <div>
                    <div className={''}>

                        {isPending && <div className={'text-center'}><Spin spinning={true}></Spin></div>}
                        {isSuccess && <div>
                            <FilterComponent
                                title="محل برگزاری کلاس"
                                options={filterOptions.classrooms}
                                value={filters.classroom_id}
                                onChange={(value) => updateFilter('classroom_id', value)}
                                type="select"
                            />
                            <FilterComponent
                                title="استاد"
                                options={filterOptions.teachers}
                                value={filters.teacher}
                                onChange={(value) => updateFilter('teacher', value)}
                                type="select"
                                placeholder="انتخاب استاد"
                            />

                            <FilterComponent
                                title="گروه آموزشی"
                                options={filterOptions.groups}
                                value={filters.group_id}
                                onChange={(value) => updateFilter('group_id', value)}
                                type="checkbox"
                            />

                            <FilterComponent
                                title="دوره"
                                options={filterOptions.courses}
                                value={filters.course_id}
                                onChange={(value) => updateFilter('course_id', value)}
                                type="select"
                                placeholder="انتخاب دوره"
                            />

                            <FilterComponent
                                title="مقطع تحصیلی"
                                options={filterOptions.grades}
                                value={filters.grade_id}
                                onChange={(value) => updateFilter('grade_id', value)}
                                type="select"
                                placeholder="انتخاب مقطع"
                            />

                            {/*<FilterComponent*/}
                            {/*    title="ترم تحصیلی"*/}
                            {/*    options={filterOptions.semesters}*/}
                            {/*    value={filters.semester_id}*/}
                            {/*    onChange={(value) => updateFilter('semester_id', value)}*/}
                            {/*    type="checkbox"*/}
                            {/*/>*/}

                            <FilterComponent
                                title="روزهای هفته"
                                options={filterOptions.weekdays}
                                value={filters.weekday}
                                onChange={(value) => updateFilter('weekday', value)}
                                type="checkbox"
                                multiple={true}
                            />

                            <FilterComponent
                                title="جنسیت"
                                options={filterOptions.genders}
                                value={filters.gender}
                                onChange={(value) => updateFilter('gender', value)}
                                type="checkbox"
                            />


                            {/*<div style={{ marginBottom: '24px' }}>*/}
                            {/*    <Title level={5} style={{ marginBottom: '12px' }}>حداکثر قیمت (تومان)</Title>*/}
                            {/*    <Slider*/}
                            {/*        min={0}*/}
                            {/*        max={5000000}*/}
                            {/*        step={100000}*/}
                            {/*        value={filters.price || 5000000}*/}
                            {/*        onChange={(value) => updateFilter('price', value)}*/}
                            {/*        tooltip={{*/}
                            {/*            formatter: (value) => value?.toLocaleString('fa-IR')*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*    <Text type="secondary" style={{ fontSize: '12px' }}>*/}
                            {/*        {(filters.price || 5000000).toLocaleString('fa-IR')} تومان*/}
                            {/*    </Text>*/}
                            {/*</div>*/}

                            {/*<div style={{marginBottom: '24px'}}>*/}
                            {/*    <Title level={5} style={{marginBottom: '12px'}}>کلاس دارای ظرفیت</Title>*/}
                            {/*    <Checkbox*/}


                            {/*        value={filters.available_capacity || ''}*/}
                            {/*        onChange={(e) => updateFilter('available_capacity', e.target.value ? parseInt(e.target.value) : null)}*/}

                            {/*    >*/}
                            {/*        فقط نمایش کلاس‌های دارای ظرفیت*/}
                            {/*    </Checkbox>*/}
                            {/*</div>*/}


                        </div>
                        }

                    </div>
                </div>

            </Drawer>


        </div>
    );
}


export default LessonFilter;


const FilterComponent = ({title, options, value, onChange, type, multiple = false, placeholder}) => {
    const threshold = 4;

    if (typeof options !== 'object') {
        options = [];
    }


    const shouldUseSelect = options?.length > threshold || type === 'select';

    if (shouldUseSelect) {
        return (
            <div style={{marginBottom: '24px'}}>
                <Title level={5} style={{marginBottom: '12px'}}>{title}</Title>
                <Select
                    style={{width: '100%'}}
                    placeholder={placeholder || `انتخاب ${title}`}
                    value={value}
                    // defaultValue={value}
                    onChange={onChange}
                    mode={multiple ? 'multiple' : undefined}
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                        (option?.children)?.toLowerCase().includes(input.toLowerCase())
                    }
                >
                    {options.map((option) => (
                        <Select.Option key={'select-option' + (option.id || option.value) + '-' + title}
                                       value={option.id || option.value}>
                            {option.title || option.name || option.label}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        );
    }

    // ✅ Radio input type
    if (type === 'radio' || !multiple) {
        return (
            <div style={{marginBottom: '24px'}}>
                <Title level={5} style={{marginBottom: '12px'}}>{title}</Title>

                <Radio.Group
                    // value={value}
                    onChange={(e) => onChange(e.target.value)}
                    style={{display: 'flex', flexDirection: 'column', gap: '8px'}}
                >
                    {options.map((option) => (

                        <Radio key={'select-radio2' + option.id + '_' + option.value + '_' + title + '_' + option.id}
                               checked={value === option.id}
                               selected={value === option.id}
                               defaultChecked={value === option.id}
                               value={option.id || option.value}>

                            {option.title || option.name || option.label}
                        </Radio>
                    ))}

                </Radio.Group>
            </div>
        );
    }

    // ✅ Default checkbox group
    return (
        <div style={{marginBottom: '24px'}}>
            <Title level={5} style={{marginBottom: '12px'}}>{title}</Title>
            <Checkbox.Group
                value={Array.isArray(value) ? value : (value ? [value] : [])}
                onChange={(checkedValues) => {
                    if (multiple) {
                        onChange(checkedValues);
                    } else {
                        onChange(checkedValues?.length > 0 ? checkedValues[0] : null);
                    }
                }}
                style={{display: 'flex', flexDirection: 'column', gap: '8px'}}
            >
                {options.map((option) => (
                    <Checkbox key={'select-checkbox' + option.id + '-' + option.value}
                              checked={value === (option.id || option.value)}>
                        {option.title || option.name || option.label}
                    </Checkbox>
                ))}
            </Checkbox.Group>
        </div>
    );
};
